import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import SplashScreen from "src/Components/SplashScreen";
import {
  getLoginUserID,
  printServiceDuration,
  truncateString,
} from "src/helpers/helperFunctions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/Store/store";
import { tooglePleaseLogin } from "src/Store/reducer";
import ProductReview from "src/Components/Customer/ProductsAndServicesComponents/ProductReview";
import FavoriteCoponent from "src/Components/GlobalComponents/FavoriteCoponent";
import ShareComponent from "src/Components/GlobalComponents/ShareComponent";
import { capitalize, Skeleton } from "@mui/material";
import { CURRENCY, ImageBaseUrl } from "src/lib/constans";
import GradientBtn from "src/Components/WebsiteComponents/GradientBtn";
import BoxWrapper from "src/Components/WebsiteComponents/BoxWrapper";
import BookHomeCareAppButton from "src/Components/BookHomeCareAppButton";

interface ProductDocument {
  _id: string;
  serviceName: string;
  shortDescription: string;
  prescriptionRequired: boolean;
  serviceDuration: string;
  healthCareProvider: string;
  overview: string;
  price: number;
  image: string;
  status: true;
  averageRating: number;
  categoryName: string[];
  [key: string]: any;
}

// import Rating from 'react-rating-stars-component';
const HomeCareDetail: React.FC = () => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { isLogged } = useSelector((store: RootState) => store.appReducer);

  const [isLoader, setIsLoader] = useState<boolean>(true);
  const [item, setItem] = useState<ProductDocument | null>(null);

  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<ProductDocument>({
      path: `/home-care-services/home/${id}${
        getLoginUserID() ? `?userId=${getLoginUserID()}` : ""
      }`,
    }); // change after tha backedn
    if (res) {
      setItem(res);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetch();
  }, [id]);

  const navigate = useNavigate();
  return (
    <>
      <div className="w-full py-4">
        <div className="view-area-width box-design p-4 flex flex-col gap-5">
          <div className="grid grid-cols-1 md:grid-cols-[4fr,8fr] gap-3">
            {isLoader ? (
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                className="rounded-md xl:rounded-lg aspect-square"
              />
            ) : (
              <div className="w-full relative border border-gray-300 flex items-center justify-center rounded-lg overflow-hidden aspect-square">
                <div className="absolute top-3 right-3 flex items-center gap-2 flex-col">
                  <FavoriteCoponent
                    id={item?._id || "dummy"}
                    liked={item?.isLiked}
                    onLikeProduct={() => {}}
                    category="homecare"
                  />
                  <ShareComponent
                    shareTitle={`${capitalize(item?.serviceName || "")}`}
                    shareText={`${item?.shortDescription}`}
                  />
                </div>
                <img
                  src={`${ImageBaseUrl}${item?.image}`}
                  alt={item?.name || ""}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <div className="product-detail-banner-content">
              <div className="flex flex-row items-center justify-between">
                {isLoader ? (
                  <Skeleton
                    variant="text"
                    width={"35%"}
                    height={"1.8vw"}
                    className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
                  />
                ) : (
                  <span className="theme-color-green my-2 font-Lexend-SemiBold block font-size-20px coma-seprated-span">
                    {item?.categoryName?.map((v: string, i: number) => (
                      <span key={i}>{v || ""}</span>
                    ))}
                  </span>
                )}
              </div>
              {isLoader ? (
                <div className="w-full">
                  <Skeleton
                    variant="text"
                    width={"30%"}
                    height={"2vw"}
                    className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
                  />
                </div>
              ) : (
                <p className="text-[#393939] line-clamp-1 mb-3 product-detail-name block font-Lexend-Regular font-size-25px">
                  {item?.serviceName}
                </p>
              )}
              <div className="text-yellow-400 text-[15px] 2xl:text-[20px] flex flex-row reviewstars items-center">
                {isLoader ? (
                  <Skeleton
                    variant="text"
                    width={"15%"}
                    height={"1.8vw"}
                    className="rounded-md min-w-[120px] max-w-[90%] min-h-5"
                  />
                ) : (
                  [1, 2, 3, 4, 5].map((v) => (
                    <FontAwesomeIcon
                      key={v}
                      className={
                        (item?.averageRating || 0) >= v
                          ? "text-[#facc15] mr-0.5"
                          : "text-[#b7b6b1] mr-0.5"
                      }
                      // size="lg"
                      icon={faStar}
                    />
                  ))
                )}
                {isLoader ? (
                  <Skeleton
                    variant="text"
                    width={"15%"}
                    height={"1.8vw"}
                    className="rounded-md ml-2 min-w-[120px] max-w-[90%] min-h-5"
                  />
                ) : (
                  <span className="text-[#707070] font-Poppins-Regular font-size-16px -mb-1 ml-2">
                    {item?.averageRating
                      ? item?.averageRating.toFixed(1)
                      : "0.0"}{" "}
                    -{" "}
                    {item?.ratingCount
                      ? item?.ratingCount.toString().padStart(2, "0")
                      : "0"}{" "}
                    Reviews
                  </span>
                )}
              </div>
              {isLoader ? (
                <div>
                  <Skeleton
                    variant="text"
                    width={"90%"}
                    height={"1.6vw"}
                    className="rounded-md min-w-[300px] max-w-[90%] min-h-5"
                  />
                  <Skeleton
                    variant="text"
                    width={"60%"}
                    height={"1.6vw"}
                    className="rounded-md min-w-[300px] max-w-[90%] min-h-5"
                  />
                </div>
              ) : (
                <p
                  title={item?.shortDescription}
                  className="text-[#707070] product-detail-des font-Lexend-Regular font-size-15px line-clamp-3"
                >
                  {item?.shortDescription}
                </p>
              )}
              <div className="homecare-Highlights-main">
                <div className="homecare-Highlights">
                  {isLoader ? (
                    <Skeleton
                      variant="text"
                      width={"30%"}
                      height={"2.2vw"}
                      className="rounded-md min-w-[150px] min-h-5"
                    />
                  ) : (
                    <h4 className="font-Lexend-Medium mb-3 text-[#3E3E3E] font-size-25px">
                      Highlights
                    </h4>
                  )}
                  <div className="flex justify-between">
                    <div>
                      {isLoader ? (
                        <Skeleton
                          variant="text"
                          width={"20%"}
                          height={"1.8vw"}
                          className="rounded-md min-w-[150px] min-h-5"
                        />
                      ) : (
                        <p className="font-Lexend-Medium text-[#3E3E3E] font-size-18px">
                          Service Duration:
                        </p>
                      )}
                      {isLoader ? (
                        <Skeleton
                          variant="text"
                          width={"20%"}
                          height={"1.8vw"}
                          className="rounded-md min-w-[150px] min-h-5"
                        />
                      ) : (
                        <p className="font-Lexend-Medium text-[#3E3E3E] font-size-18px">
                          Healthcare Provider:
                        </p>
                      )}
                    </div>
                    <div>
                      {isLoader ? (
                        <Skeleton
                          variant="text"
                          width={"20%"}
                          height={"1.8vw"}
                          className="rounded-md min-w-[150px] min-h-5"
                        />
                      ) : (
                        <p className="font-Lexend-Medium text-[#707070] font-size-18px text-right">
                          {printServiceDuration(item?.serviceDuration || "")}
                        </p>
                      )}
                      {isLoader ? (
                        <Skeleton
                          variant="text"
                          width={"20%"}
                          height={"1.8vw"}
                          className="rounded-md min-w-[150px] min-h-5"
                        />
                      ) : (
                        <p className="font-Lexend-Medium text-[#707070] font-size-18px text-right">
                          {item?.healthCareProvider || ""}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex gap-4 items-center w-fit">
                  {isLoader ? (
                    <Skeleton
                      variant="text"
                      width={"22%"}
                      height={"2.3vw"}
                      className="rounded-md min-w-[150px] min-h-5"
                    />
                  ) : (
                    <span className="text-[#202020] font-Poppins-SemiBold  font-size-26px">
                      {CURRENCY} {item?.price || ""}
                    </span>
                  )}
                </div>
                {isLoader ? (
                  <Skeleton
                    variant="rectangular"
                    width={"30%"}
                    height={"2.6vw"}
                    className="rounded-full min-w-[150px] min-h-6"
                  />
                ) : (
                  <BookHomeCareAppButton
                    id={item?._id || ""}
                    fontsizeBtn="font-size-18px"
                    fontfamilyBtn="font-Lexend-Medium"
                    btnExtraStyle={{ width: "fit-content" }}
                    ButtonText="Book Appointment"
                  />
                )}
              </div>
            </div>
          </div>
          <BoxWrapper
            title="Overview"
            loading={isLoader}
            productDetailBoxDesign
          >
            {isLoader ? (
              <div>
                <Skeleton
                  variant="text"
                  width={"80%"}
                  height={"1.6vw"}
                  className="rounded-md min-w-[300px] max-w-[90%] min-h-5"
                />
                <Skeleton
                  variant="text"
                  width={"60%"}
                  height={"1.6vw"}
                  className="rounded-md min-w-[300px] max-w-[90%] min-h-5"
                />
              </div>
            ) : (
              <div
                contentEditable="false"
                className="client-html-content"
                dangerouslySetInnerHTML={{ __html: item?.overview || "" }}
              />
            )}
          </BoxWrapper>
          <ProductReview productId={id} />
        </div>
      </div>
    </>
  );
};

export default HomeCareDetail;
